import { Link } from "react-router-dom";

export function ActionsModulePlaceholder() {
  return (
    <section className="card">
      <h3 className="page-title" style={{ fontSize: "1.05rem" }}>
        Ações de suporte
      </h3>
      <p className="section-description">
        Conceda dias de plano gratuito (cortesia) para empresas vinculadas ao seu usuário.
      </p>
      <Link
        className="primary-button"
        to="/suporte/cortesia"
        style={{ display: "inline-block", marginTop: 12, textDecoration: "none" }}
      >
        Abrir cortesia
      </Link>
    </section>
  );
}
